export default "__VITE_ASSET__DOUGxsx4__"